import { render } from "./List.vue?vue&type=template&id=038e56f1&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=038e56f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-038e56f1"

export default script